<template>
    <ModalFormCard class="modal-default"
        :action='"/zapo/landing-page/question" + (editingModel?.id ? "/" + editingModel.id : "")'
        :submittedCallback='submittedCallback'
    >
        <template #title>Edit question</template>

        <template #default="{ saving, errors }">
            <Input
                v-model:value="value.title"
                groupClass="bg-grey text-15" class=''
                label="Title"
                name="title"
                placeholder="Title"
            />

            <Textarea
                v-model:value="value.question"
                name="question"
                groupClass="bg-grey text-15" class=' mt-4'
                label="Question" rows='10'
            />

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default">
                    Update question
                </ButtonSaving>

                <button class="h-12 button-purple" v-if="value.id" @click="destroy" type='button'>
                    Delete question
                </button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        created() {
            this.value = {
                id: this.editingModel?.id,
                title: this.editingModel?.title,
                question: this.editingModel?.question,
            }
        },

        methods: {
            submittedCallback() {
                this.$event.$emit('modal-form-completed')
                this.$event.$emit('modal-close')
                this.$event.$emit('refresh-lp-preview')
            },

            destroy() {
                this.$axios.delete('/zapo/landing-page/question/' + this.value.id).then(() => {
                    this.submittedCallback()
                });
            }
        }
    }
</script>